import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import dayjs from "dayjs";
import typography from "../../cssUtils/typography";
import { ColorsConstants, grayFontColor } from "../../cssUtils/constants";

// One segment per configured reminder stage (D-9 → D-1). "Failed" means the
// reminder couldn't be sent — WhatsApp delivery/read status isn't shown here.
export const PROGRESS_STATUS = {
  sent: { label: "Sent", sx: { bgcolor: ColorsConstants.primaryBackgroundColor } },
  failed: { label: "Failed", sx: { bgcolor: "#F07A2B" } },
  skipped: { label: "Skipped", sx: { bgcolor: "#E4E8EF" } },
  scheduled: { label: "Scheduled", sx: { bgcolor: "transparent", border: "1px dashed #B8C1D1" } },
};

const SEGMENT_SX = { width: 16, height: 6, borderRadius: 3, boxSizing: "border-box" };

const ReminderProgress = ({ progress }) => {
  if (!progress) return <Typography sx={typography.bodyLarge}>-</Typography>;
  if (!progress.stages.length) {
    return (
      <Typography sx={{ ...typography.bodySmall, color: grayFontColor }}>No reminders scheduled</Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {progress.stages.map((stage) => {
          const status = PROGRESS_STATUS[stage.status] || PROGRESS_STATUS.scheduled;
          return (
            <Tooltip
              key={stage.stage}
              title={`${stage.label} · ${dayjs(stage.date).format("D MMM")} · ${status.label}`}
              arrow
            >
              <Box sx={{ ...SEGMENT_SX, ...status.sx }} />
            </Tooltip>
          );
        })}
      </Box>
      <Typography sx={{ ...typography.bodySmall, color: grayFontColor, whiteSpace: "nowrap" }}>
        {progress.summary}
      </Typography>
    </Box>
  );
};

export const ReminderProgressLegend = () => (
  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
    {Object.entries(PROGRESS_STATUS).map(([key, { label, sx }]) => (
      <Box key={key} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Box sx={{ ...SEGMENT_SX, ...sx }} />
        <Typography sx={{ ...typography.bodySmall, color: grayFontColor }}>{label}</Typography>
      </Box>
    ))}
  </Box>
);

export default ReminderProgress;
